// extracted by mini-css-extract-plugin
export default {"profilePill":"profile_pill-module___profilePill___c49afc3f","avatar":"profile_pill-module___avatar___dfde2df7","closeIcon":"profile_pill-module___closeIcon___ff0e231f"};